// extracted by mini-css-extract-plugin
export default {"questionMarkContainer":"QuestionMarkAnimation_questionMarkContainer__Z6sh0","questionMarkAnimation":"QuestionMarkAnimation_questionMarkAnimation__VMLcc"};